import * as URLConfig from "@frameworks/web/config/domain";
var config = URLConfig.config;
var pdfUrls = {
    baseUrl: "https://www.nuvamawealth.com/",
    ewweb: "ewwebimages",
    webfile: "/webfiles",
    ebl: "/EBL",
    eblFinancial: "/EBL-Financials",
    announcement: "/2022-23Announcement",
    announcement2: "/2023-24Announcement",
    announcement3: "/2024-25Announcement",
    notice: "/Notices",
    disclaimer: "/disclaimer",
};
export default pdfUrls;
